import { QueryFunctionContext } from '@tanstack/react-query';
import { CompositeMatchingParams, CompositeMatchingResponse } from 'src/types/compositeMatching';
import { DesignConductorService } from 'src/services/DesignConductorService';

export const QUERY_KEY = 'compositeMatching';

export type CompositeMatchingQueryKey = [
    typeof QUERY_KEY,
    string | undefined | false,
    CompositeMatchingParams,
];

export const queryCompositeMatching = async ({
    queryKey,
}: QueryFunctionContext<CompositeMatchingQueryKey>): Promise<CompositeMatchingResponse> => {
    const [, accessToken, params] = queryKey;

    if (!accessToken) {
        throw new Error('No access token provided');
    }

    return DesignConductorService.getCompositeMatching(params, params.sendAuthHeader === true ? accessToken : undefined);
};
